import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboardIcon, PackageIcon, ShoppingCartIcon, LogOutIcon, MenuIcon, XIcon, ShieldIcon, TagIcon, SettingsIcon } from 'lucide-react';
import { useStore } from '../../context/StoreContext';
const navItems = [{
  to: '/admin/dashboard',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  to: '/admin/products',
  label: 'Products',
  icon: PackageIcon
}, {
  to: '/admin/orders',
  label: 'Orders',
  icon: ShoppingCartIcon
}, {
  to: '/admin/promos',
  label: 'Promo Codes',
  icon: TagIcon
}, {
  to: '/admin/settings',
  label: 'Settings',
  icon: SettingsIcon
}];
export function AdminLayout() {
  const {
    user,
    logout
  } = useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  if (!user?.isAdmin) {
    navigate('/admin');
    return null;
  }
  const handleLogout = () => {
    logout();
    navigate('/admin');
  };
  const SidebarContent = () => <>
      <div className="p-5 border-b border-slate-700" data-id="element-460">
        <div className="flex items-center gap-3" data-id="element-461">
          <div className="w-9 h-9 bg-sky-600 rounded-lg flex items-center justify-center" data-id="element-462">
            <ShieldIcon className="w-5 h-5 text-white" data-id="element-463" />
          </div>
          <div data-id="element-464">
            <h2 className="font-bold text-white text-sm" data-id="element-465">Sky Brand</h2>
            <p className="text-xs text-slate-400" data-id="element-466">Admin Panel</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1" data-id="element-467">
        {navItems.map(item => {
        const isActive = location.pathname === item.to;
        return <Link key={item.to} to={item.to} onClick={() => setIsSidebarOpen(false)} className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-sky-600 text-white' : 'text-slate-400 hover:bg-slate-800 hover:text-white'}`} data-id="element-468">
              <item.icon className="w-5 h-5" data-id="element-469" />
              {item.label}
            </Link>;
      })}
      </nav>

      <div className="p-4 border-t border-slate-700" data-id="element-470">
        <div className="px-4 py-2 mb-2" data-id="element-471">
          <p className="text-sm font-medium text-white truncate" data-id="element-472">{user.name}</p>
          <p className="text-xs text-slate-400 truncate" data-id="element-473">{user.email}</p>
        </div>
        <button onClick={handleLogout} className="flex items-center gap-3 w-full px-4 py-3 text-red-400 hover:bg-red-900/30 rounded-lg text-sm font-medium transition-colors" data-id="element-474">
          <LogOutIcon className="w-5 h-5" data-id="element-475" /> Logout
        </button>
      </div>
    </>;
  return <div className="min-h-screen bg-slate-100 flex" data-id="element-476">
      {/* Desktop Sidebar */}
      <aside className="hidden lg:flex w-64 bg-slate-900 flex-col fixed inset-y-0 left-0 z-30" data-id="element-477">
        <SidebarContent data-id="element-478" />
      </aside>

      {/* Mobile Sidebar */}
      {isSidebarOpen && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-479">
          <div className="absolute inset-0 bg-black/50" onClick={() => setIsSidebarOpen(false)} data-id="element-480" />
          <aside className="absolute top-0 left-0 bottom-0 w-64 bg-slate-900 flex flex-col" data-id="element-481">
            <SidebarContent data-id="element-482" />
          </aside>
        </div>}

      {/* Main Content */}
      <div className="flex-1 lg:ml-64" data-id="element-483">
        {/* Top Bar */}
        <header className="bg-white border-b border-slate-200 px-4 lg:px-8 py-4 flex items-center justify-between sticky top-0 z-20" data-id="element-484">
          <button onClick={() => setIsSidebarOpen(true)} className="lg:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-lg" data-id="element-485">
            <MenuIcon className="w-5 h-5" data-id="element-486" />
          </button>
          <h1 className="text-lg font-bold text-slate-900 hidden lg:block" data-id="element-487">
            {navItems.find(n => n.to === location.pathname)?.label || 'Admin'}
          </h1>
          <div className="text-sm text-slate-500" data-id="element-488">
            Welcome,{' '}
            <span className="font-medium text-slate-900" data-id="element-489">{user.name}</span>
          </div>
        </header>

        <main className="p-4 lg:p-8" data-id="element-490">
          <Outlet data-id="element-491" />
        </main>
      </div>
    </div>;
}